<template>
  <div>
    <v-card
      class="ma-4"
      elevation="4"
    >
      <v-card-title class="font-weight-bold">
        いいねしたコード
      </v-card-title>

      <v-divider />

      <div class="pa-4">
        <ResultList :query="query" />
      </div>
    </v-card>
  </div>
</template>


<script>
import firebase from "@/firebase/firebase.js"
import {db} from "@/firebase/db.js"
import ResultList from '@/components/ResultList.vue'

export default {
  components: {
    ResultList,
  },
  data: () => ({
    query: null,
  }),
  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.query = db.collectionGroup("codes").where("likes", "array-contains", user.uid)
      }
    })
  },
};
</script>

